import {
  GetS3PresignedUploadUrlResponseBodyType,
  S3PresignedUploadScenario,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

export interface GetS3PresignedUploadUrlArgs {
  scenario: S3PresignedUploadScenario;
  // Required by `chat-attachment`, ignored by `product-upload`. The server-side
  // chat-attachment handler uses these to construct a per-file S3 key and to
  // run `checkChatAttachment` against the per-MIME size cap.
  filename?: string;
  mediaType?: string;
  size?: number;
}

const getS3PresignedUploadUrl = async (
  args: GetS3PresignedUploadUrlArgs | S3PresignedUploadScenario
): Promise<GetS3PresignedUploadUrlResponseBodyType> => {
  const params: GetS3PresignedUploadUrlArgs =
    typeof args === "string" ? { scenario: args } : args;
  const resp = await api.get<GetS3PresignedUploadUrlResponseBodyType>(
    `/v2/s3-files/presigned-upload-url`,
    { params }
  );
  return resp.data;
};

export const useGetS3PresignedUploadUrl = () => {
  return useMutation({
    mutationFn: getS3PresignedUploadUrl,
  });
};
